module.exports = __webpack_public_path__ + "img/footer.8481c1bc.svg";